export const ADD_MODAL_IS_OPEN = "SUBSCRIPTIONS:ADD_MODAL_IS_OPEN";
export const ADD_IS_LOADING = "SUBSCRIPTIONS:ADD_IS_LOADING";
export const ADD_IS_DONE = "SUBSCRIPTIONS:ADD_IS_DONE";
export const CLEAR_DATA = "SUBSCRIPTIONS:CLEAR_DATA";
export const ADD_ERROR = "SUBSCRIPTIONS:ADD_ERROR";
